import CountUp from "countup";
import Component from "@base/js/component";

export default class StatCard extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".stat-card";

  constructor() {
    super();

    this.animateNumber = this.animateNumber.bind(this);
  }

  // Will be called upon component instantiation
  afterInit() {
    this.animateNumber();
  }

  animateNumber() {
    const allNumbers = document.querySelectorAll(
      ".stat-card__number--animated"
    );

    if (!allNumbers.length) return;

    allNumbers.forEach((el) => {
      const { value } = el.dataset;

      if (!value) return;

      const parts = value.split(".");
      const countUp = new CountUp(
        el,
        0,
        parseFloat(value),
        parts[1]?.length || 0
      );

      if (!countUp.error) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                countUp.start();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.2 }
        );

        observer.observe(el);
      } else {
        // eslint-disable-next-line no-console
        console.error(countUp.error);
      }
    });
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
StatCard.init();
